import { useTranslation } from "react-i18next"
import { Route } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"

const DailyRoutesSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const enabled = Boolean(useFeatureFlagEnabled("delivery-manifest-route"))
  if (!enabled) return null
  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.DAILY_ROUTES}
      icon={Route}
      activeIcon={Route}
      tooltipText={t("app.sidebar.dailyRoutes")}
      className={className}
    />
  )
}

export default DailyRoutesSidebarButton
